<template>
  <div v-if="options" class="modal__generic">
    <h3 class="modal__header">
      {{ tStatic('selectMachineModalHeading').replace('{0}', options.machine.name) }}
    </h3>

    <p class="modal__text">
      {{ tStatic('selectMachineModalText').replace('{0}', options.machine.name) }}
    </p>
    <div class="modal__spacer">
      <oie-base-checkbox v-model="rememberMyChoice" is-for="remember-spare-parts-always-set-machine" :text="tStatic('selectMachineModalRememberChoiceCheckboxLabel')"></oie-base-checkbox>
    </div>
    <div class="modal__actions">
      <oie-base-button
        :css-classes="'button--with-border button--blue'"
        :text="tStatic('selectMachineModalConfirmButton').replace('{0}', options.machine.name)"
        @click="selectMachine"></oie-base-button>

      <oie-base-button
        css-classes="button--true-ghost"
        :text="tStatic('selectMachineModalDismissButton').replace('{0}', options.machine.name)"
        @click.native="dismiss"></oie-base-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Bus from '@/core/message-bus'

export default {
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      rememberMyChoice: false
    }
  },
  methods: {
    ...mapActions('myMachines', ['setGlobalMyMachinesSelection']),
    dismiss() {
      if(this.rememberMyChoice) {
        localStorage.setItem('sparePartsAlwaysSetMachine', 'false')
      }
      this.$modal.hide(this.options.name)
    },
    selectMachine() {
      if(this.rememberMyChoice) {
        localStorage.setItem('sparePartsAlwaysSetMachine', 'true')
      }

      this.setGlobalMyMachinesSelection({ machineId: this.options.machine.machineId, machineOwnerId: this.options.machine.machineOwnerId })
      Bus.publish('modal.hide.select-machine')
    }
  }
}
</script>

<style lang="scss">
.modal__actions {
  display: flex;
  align-items: center;
}

.modal__actions > * + * {
  margin-left: measure(quarter);
}
</style>
